// @flow weak

import PropTypes from 'prop-types';
import React from 'react';
// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9
import _ from 'lodash';
import bemify from 'bemify-js';

import 'app/common/components/TruncatedText.scss';

const TruncatedText = props => {
  const className = bemify('truncated-text', {
    [props.className]: !!props.className,
    '--block': !!props.block,
  });
  const childrenArray = React.Children.toArray(props.children);
  const isEveryChildPrimitive = childrenArray.every(
    child => _.isString(child || '') || _.isNumber(child)
  );
  const joinedPrimitiveChildren = isEveryChildPrimitive
    ? childrenArray.join(' ')
    : undefined;
  const title = props.title ? props.title : joinedPrimitiveChildren;
  return (
    <span className={className} title={title}>
      {props.children}
    </span>
  );
};

TruncatedText.propTypes = {
  block: PropTypes.bool,
  shouldRenderTitleAttribute: PropTypes.bool,
};

TruncatedText.defaultProps = {
  shouldRenderTitleAttribute: true,
};

export default TruncatedText;
